<template>
    <v-layout wrap>
        <v-navigation-drawer class="hide-scroll" absolute permanent right v-bind:style="{width: 800}">
            <v-list class="pa-1">
                <v-list-item>
                    <v-list-item-avatar>
                        <img :src="img">
                    </v-list-item-avatar>
                    
                    <slot name="headline"></slot>

                    <v-tooltip left>
                        <template v-slot:activator="{ on }">
                            <v-btn icon @click.native="closePanel()">
                                <v-icon color="grey lighten-1">mdi-close</v-icon>
                            </v-btn>
                            <v-btn icon v-on="on" @click="openDoc()">
                                <v-icon color="grey lighten-1">mdi-information</v-icon>
                            </v-btn>
                        </template>
                        <slot name="descriptionText"></slot>
                    </v-tooltip>
                </v-list-item>
            </v-list>

            <v-list class="pt-0" dense flat>
                <slot name="edit-layout">
                    <v-layout wrap>
                        <v-flex shrink style="width: 230px;">
                            <v-card flat>
                                <v-card-text>
                                    <v-text-field                                
                                            label="Name"
                                            v-model="value.object.metadata.name"
                                            autofocus
                                            :disabled="readOnly"
                                    ></v-text-field>

                                    <slot name="edit-property"></slot>
                                    
                                    <kube-attr-field 
                                            v-model="value" 
                                            :readOnly="readOnly"
                                    ></kube-attr-field>
                                </v-card-text>
                            </v-card>
                        </v-flex>
                        <v-flex>
                            <kube-yaml-editor
                                    v-model="value.object"
                                    :readOnly="readOnly"
                            ></kube-yaml-editor>
                        </v-flex>
                    </v-layout>
                </slot>
            </v-list>
            
        </v-navigation-drawer>
    </v-layout>
</template>

<script>

    export default {
        name: 'kubernetes-common-panel',
        props: {
            readOnly: Boolean,
            value: Object,
            img: String,
        },
        computed: {
            descriptionText() {
                return '';
            },
        },
        data: function () {
            return {}
        },
        methods: {
            closePanel() {
                this.$emit('close')
            },
            openDoc(desDoc) {
                this.$emit('openDesDoc', desDoc)
            },
        }
    }
</script>


